import { State as LoginState } from '@telstra-connect/login';

export function getDefaultCompanyId(userState: LoginState.IUserState) {
    // get Default Company
    return userState?.oauth ? userState.oauth.profile.defaultCompanyId : null;
}
